module.exports = __webpack_public_path__ + "img/404.541849db.svg";